import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { Role, SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { SubscriptionService } from '../../services/subscription.service';
import { UserApiService } from '../../services/user-api.service';
import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-premium-member-greeting-popup',
    templateUrl: './premium-member-greeting-popup.component.html',
    styleUrls: ['./premium-member-greeting-popup.component.scss'],
    standalone: false
})
export class PremiumMemberGreetingPopupComponent implements OnInit {
   private destroy$: Subject<void> = new Subject<void>();
   userNewRole: Role = null;
   planText: string = '';
   userDataLoader: boolean = false;
   isUserPhoneNumberAvailable: boolean = false;
   userPlan: string = ''
   private userDataReady!: Promise<void>;
   private resolveUserDataReady!: () => void;

   constructor(
      private congratulationsModal: NgbActiveModal,
      private userApiServices: UserApiService,
      private sharedService: SharedService
   ) { }

   ngOnInit(): void {
      SubscriptionService.subscriptionData
         .pipe(takeUntil(this.destroy$))
         .subscribe((data: SubscriptionInfoModel) => {
            this.userNewRole = data.newRole;
         });

      this.getUserDetails()
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }

   getPlanText(role: string) {
      switch (role) {
         case 'STARTER':
            return 'Foundation';
         case 'PREMIUM':
            return 'Invest';
         case 'PREMIUM_PLUS':
            // return 'Pro';
            return 'Invest Plus';
         case 'PROFESSIONAL':
            return 'Professional';
         default:
            return role
               .replace(/_/g, ' ')
               .replace(/\b\w/g, char => char.toUpperCase())
               .replace(/\B\w/g, char => char.toLowerCase());
      }
   }

   private getUserDetails() {
      this.userDataReady = new Promise<void>(resolve => {
         this.resolveUserDataReady = resolve;
      });
      this.userDataLoader = true;
      this.userApiServices.getUserData(true).pipe(takeUntil(this.destroy$)).subscribe({
         next: (data) => {
            if (data) {
               this.userPlan = data.app_role.toUpperCase();
               this.isUserPhoneNumberAvailable = !!data.phone;
               this.userDataLoader = false;
            }
            this.resolveUserDataReady();
         },
         error: (error) => {
            console.error(error);
            this.userDataLoader = false;
            this.isUserPhoneNumberAvailable = true; // Fail safe: assume available on error
            this.resolveUserDataReady();
         },
         complete: () => {
            this.userDataLoader = false;
            this.resolveUserDataReady();
         },
      })
   }

   async closeGreetingsPopup() {
      this.congratulationsModal.close();
      try {
         await this.userDataReady;
      } catch (e) {
         console.warn('User data fetch interrupted');
      }

      if (!this.isUserPhoneNumberAvailable) {
         this.openPhoneNumberPopup()
      }
   }

   openPhoneNumberPopup() {
      this.sharedService.openPersonalizedAssistancePopup()
   }

}
